let datemMnthYr = new Date(),
  currentdate =
    datemMnthYr.getFullYear() +
    '-' +
    ('0' + (datemMnthYr.getMonth() + 1)).slice(-2) +
    '-' +
    datemMnthYr.getDate();

let datetime = new Date(),
  currenttime =
    datetime.getHours() +
    ':' +
    datetime.getMinutes() +
    ':' +
    datetime.getSeconds();
export { currentdate, currenttime };

let nowWithZero = new Date();

let currentdateWithZero =
  nowWithZero.getUTCFullYear() +
  '-' +
  ('0' + (nowWithZero.getUTCMonth() + 1)).slice(-2) +
  '-' +
  ('0' + nowWithZero.getUTCDate()).slice(-2);

let currenttimeWithZero =
  ('0' + nowWithZero.getUTCHours()).slice(-2) +
  ':' +
  ('0' + nowWithZero.getUTCMinutes()).slice(-2) +
  ':' +
  ('0' + nowWithZero.getUTCSeconds()).slice(-2);

export { currentdateWithZero, currenttimeWithZero };
